<script>
    import { trainerTexts as texts } from './trainerTexts.js';
    export let lang;
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    function logout() {
        dispatch('logout');
    }
</script>

<div class="navbar">
    <div class="navbar__textbox">
        <div class="navbar__icons">
            <!-- <a
                href="https://mindlab.pl/"
                target="blank"
                class="social social--home"
            /> -->
            <a
                href="https://mindlab.pl/"
                target="blank"
                class="social social--home"
            />
            <a
                href="https://pl-pl.facebook.com/mindlabcompany/"
                target="blank"
                class="social social--facebook"
            />
            <a
                href="https://www.instagram.com/_mindlab"
                target="blank"
                class="social social--instagram"
            />
            <a
                href="https://pl.linkedin.com/company/mindlab-sp-z-o-o-"
                target="blank"
                class="social social--linkedin"
            />
            <a
                href="https://www.youtube.com/user/MindLabPL"
                target="blank"
                class="social social--youtube"
            />
        </div>
        <div class="navbar__login">
            <button class="btn-login" on:click={logout}
                >{texts[lang].logout}</button
            >
        </div>
    </div>
</div>
